import { render, staticRenderFns } from "./the-top-message-collection.vue?vue&type=template&id=3daf67a4&scoped=true&"
import script from "./the-top-message-collection.vue?vue&type=script&lang=js&"
export * from "./the-top-message-collection.vue?vue&type=script&lang=js&"
import style0 from "./the-top-message-collection.vue?vue&type=style&index=0&id=3daf67a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf67a4",
  null
  
)

export default component.exports